import { StoreEditIcon } from './StoreEditIcon';

/**
 * author: Colton Wiscombe
 * id 738C22C4-6605-437A-821A-10CF8E151422
 * name store-edit
 * version: 6.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/store-edit.svg
 * tags
 * - Places 
 * - Shopping 
 * - Edit / Modify 
 */
export const ShopEditIcon = StoreEditIcon;
export default ShopEditIcon